import { pageHead } from "@app/framework/meta";
import { SenaatAndInvestmentCasePage } from "@modules/investor-relations/pages/SenaatAndInvestmentCasePage";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function InvestmentCase() {
  useLoaderData();

  return <SenaatAndInvestmentCasePage />;
}

export const meta: MetaFunction = () => {
  return pageHead({
    title: trans("senaatAndInvestmentCase"),
    appendAppName: true,
  });
};
